{
  "languages": {
    "en": "English",
    "it": "Italiano"
  },
  "labels": {
    "page-title": "Misure",
    "name": "Nome",
    "measure": "Misura",
    "type": "Tipo",
    "measures": "Misure",
    "search": "cerca",
    "create-measure": "Crea misura",
    "cancel": "Chiudi",
    "save": "Salva",
    "duplicate": "Duplica",
    "delete": "Elimina",
    "refresh": "Ricarica",
    "description": "Descrizione",
    "required": "Campo obbligatorio",
    "open": "Apri",
    "deleteMulti": "Elimina selezione",
    "role": "Ruolo",
    "send": "Invia",
    "select": "Seleziona",
    "context": "Contesto",
    "health-healthy": "In salute",
    "health-unhealthy": "Non in salute",
    "health-unknown": "Sconosciuto",
    "last-check": "Ultimo controllo"
  },
  "strings": {
    "new-measure": "nuova misura",
    "no-measures": "Questa lista è vuota",
    "please-add-measure": "Aggiungi una nuova Misura",
    "delete-measure-question": "Sei sicuro di voler eliminare questa Misura?",
    "delete-measure-disclaimer-part1": "Eliminando questa Misura la rimuoverai definitivamente e tutti i KPI associati che dipendono da essa. Questa azione non può essere annullata.",
    "delete-measure-disclaimer-part2": "Se sei sicuro, clicca su ELIMINA per confermare.",
    "delete-multiple-measure-question": "Sei sicuro di voler eliminare le Misure selezionate?",
    "delete-measure-text": "Misura eliminata",
    "delete-multiple-text": "Misure eliminate",
    "delete-measure-tooltip": "Elimina questa Misura",
    "hint-insert-new-name": "Inserisci un nuovo nome per la misura",
    "duplicate-advice": "ATTENZIONE: per motivi di sicurezza, se la Misura richiede delle credenziali, queste NON saranno duplicate nella nuova misura",
    "name-required": "Il nome è obbligatorio",
    "name-less-20-chars": "La massima lunghezza consentita è di 20 caratteri",
    "value-required": "Un valore è obbligatorio"
  },
  "errors": {
    "measure-name-exists": "Questo nome è già in uso"
  }
}